<template>
  <div>
    <div class="row">
      <div class="col-2 text-center">
        <router-link to="/profile/business/advertising/coupons/overview">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'overview',
                              'yellow-underline': endPath === 'overview' }">Overview</h4>
        </router-link>
      </div>
      <div class="col-2 text-center">
        <router-link to="/profile/business/advertising/coupons/details">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'details',
                              'yellow-underline': endPath === 'details' }">Details</h4>
        </router-link>
      </div>
      <div class="col-2 text-center">
        <router-link to="/profile/business/advertising/coupons/messages">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'messages',
                              'yellow-underline': endPath === 'messages' }">Messages</h4>
        </router-link>
      </div>
      <div class="col-2 text-center">
        <router-link to="/profile/business/advertising/coupons/legal">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'legal',
                              'yellow-underline': endPath === 'legal' }">Legal</h4>
        </router-link>
      </div>
      <div class="col-2 text-center">
        <router-link to="/profile/business/advertising/coupons/checkout">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'checkout',
                              'yellow-underline': endPath === 'checkout' }">Checkout</h4>
        </router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      endPath: null
    }
  },
  watch: {
    '$route' (to, from) {
      this.setEndPath()
    }
  },
  methods: {
    setEndPath () {
      var pathList = (this.$route.path).split('/')
      this.endPath = pathList[5]
    }
  },
  computed: {
    ...mapGetters('business', [
      'adminComplete'
    ])
  },
  created () {
    this.setEndPath()
    console.log(this.adminComplete)
  }
}
</script>

<style scoped>
.black-underline {
  border-bottom: solid;
}

.yellow-underline {
  border-bottom: solid;
  border-color: #feedaa;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/advertising/coupons/CouponAdvertising.vue